import { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../utils/api';

export default function VerifyEmail() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    const initialized = useRef(false);

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage(t('auth.noToken'));
            return;
        }

        if (!initialized.current) {
            initialized.current = true;
            api.verifyEmail(token)
                .then(res => {
                    setStatus('success');
                    setMessage(res.message || t('auth.emailVerified'));
                })
                .catch(err => {
                    setStatus('error');
                    setMessage(err.message || t('auth.verificationFailed'));
                });
        }
    }, [token, t]);

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg-base)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1.5rem', fontFamily: "'Roboto', sans-serif" }}>
            <div style={{ width: '100%', maxWidth: '480px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '3rem 2rem', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--orange-dark), var(--orange), var(--orange-light))' }} />

                <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.5rem', letterSpacing: '0.08em', color: '#ffffff', marginBottom: '1rem' }}>
                    {t('auth.emailVerification')}
                </h1>

                {status === 'verifying' && (
                    <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>{t('auth.verifying')}</p>
                )}

                {status === 'success' && (
                    <>
                        <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(34,197,94,0.1)', border: '2px solid #22c55e', color: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', margin: '0 auto 1.5rem' }}>
                            ✓
                        </div>
                        <p style={{ color: '#e5e7eb', marginBottom: '2rem' }}>{message}</p>
                        <Link to="/login" className="btn-orange" style={{ display: 'inline-flex', justifyContent: 'center', width: '100%', padding: '0.9rem' }}>
                            {t('auth.proceedToLogin')}
                        </Link>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(239,68,68,0.1)', border: '2px solid #ef4444', color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', margin: '0 auto 1.5rem' }}>
                            ✕
                        </div>
                        <p style={{ color: '#fca5a5', marginBottom: '2rem' }}>{message}</p>
                        <Link to="/" className="btn-outline-orange" style={{ display: 'inline-flex', justifyContent: 'center', width: '100%', padding: '0.9rem' }}>
                            {t('auth.returnToHome')}
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
